import { render, staticRenderFns } from "./DeviceTemplateComponent.vue?vue&type=template&id=576661ac&scoped=true&"
import script from "./DeviceTemplateComponent.vue?vue&type=script&lang=ts&"
export * from "./DeviceTemplateComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceTemplateComponent.vue?vue&type=style&index=0&id=576661ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576661ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VHover,VRow,VTextField})
